import { ITableProps, Table } from "ka-table";
import {
  DataType,
  SortingMode,
  EditingMode,
  PagingPosition,
} from "ka-table/enums";
import moment from "moment";
import { FaFilePdf } from "react-icons/fa6";
import { RiFileExcel2Line } from "react-icons/ri";
// import { PaymentTable } from '../../../models/userModels';
// import { useLanguage } from '../../../context/LanguageContext';
// import useResponsive from '../../../hooks/useResponsive';

import SearchIcon from "@mui/icons-material/Search";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import CloseIcon from "@mui/icons-material/Close";
import "ka-table/style.css";
// import "./custome-theme.scss";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputBase,
  Pagination,
  Typography,
} from "@mui/material";
import { Dispatch, FC, JSX, SetStateAction, useEffect, useState } from "react";
import { ActionButtonTypes, KATableHeaderTypes } from "./SweetTable.interface";
// import { useLanguage } from "../../context/LanguageContext";
// import PTaxAutoCompleteWrapper from "../PTaxAutoCompleteWrapper";
type TableControllerProps = {
  tableTitle?: string;
  searchText?: string;
  setSearchText?: Dispatch<SetStateAction<string>>;
  actionBtns?: Array<ActionButtonTypes>;
  downLoadPDF?: boolean;
  downloadEXCEL?: boolean;
  pdfAction?: any;
  excelAction?: any;
  tableColumns: Array<KATableHeaderTypes>;
  tableData: Array<any>;
  isSSR?: boolean;
  searchAction?: (params: any) => void;
  actionBtnsReq?: boolean;
  orientaion?: "landscape" | "portrait";
  ExcelDownloadFromServer?: any;
  searchTitle?: string;
  searchDropdownLabel?: any;
  searchDropdownKey?: any;
  searchDropdownList?: any[];
  FormHandler?: any;
  setSearchKeyVal?: any;
  isTypeSearch?: boolean;
  searchClearAction?: any;
  filtersAllow?: boolean;
  ColumnSettings?:boolean
};
const TableController: FC<TableControllerProps> = ({
  tableTitle = "table title",
  searchText,
  setSearchText,
  downLoadPDF = false,
  downloadEXCEL = false,
  pdfAction,
  excelAction,
  actionBtns = [],
  tableColumns,
  tableData,
  isSSR,
  searchAction,
  actionBtnsReq = true,
  orientaion,
  ExcelDownloadFromServer,
  searchTitle,
  searchDropdownKey,
  searchDropdownLabel,
  searchDropdownList,
  FormHandler,
  setSearchKeyVal,
  isTypeSearch = false,
  searchClearAction,
  filtersAllow = true,
  ColumnSettings=false,
}): JSX.Element => {
  const [dataGrid, setDataGrid] = useState<any[]>([]);
  // const { changeLang, getLng } = useLanguage();
  useEffect(() => {
    if (!!tableData && Array.isArray(tableData)) {
      setDataGrid(
        tableData?.map(item =>
          Object.keys(item).reduce((m, n) => ({ ...m, [n]: `="${String(item[n])}"` }), {}),
        ),
      );
    }
  }, [tableData]);
  const handleChooseAction = (value: any, callBack: any) => {
    callBack(value);
    setSearchKeyVal(value);
  };
  const searchClear = () => {
    FormHandler.setValue("search_dropdown", null);
    searchClearAction?.();
  };
  return (
    <Grid
      container
      sx={{
        marginBottom: "5px",
      }}
    >
      {filtersAllow && (
        <Grid
          item
          xs={12}
          sm={10}
          md={6}
          lg={8}
          xl={8}
          sx={{
            display: "flex",
            gap: "10px",
            height: "30px",
            justifyContent: "flex-start", // Align buttons and search to the start
            alignItems: "center", // Center vertically
            flexWrap: "nowrap", // Ensure no line breaks
          }}
        >
          {/* CSV Download Button */}
          {!!downloadEXCEL ? (
            isSSR ? (
              <Button
                onClick={ExcelDownloadFromServer}
                size="small"
                variant="outlined"
                style={{
                  border: "1px solid #1976d2",
                  backgroundColor: "#f5f5f5",
                  color: "#1976d2",
                  // height: 28,

                  textDecoration: "none",
                  // color: "#1976d2",
                  padding: "0px 10px",
                  display: "flex",
                  alignItems: "center",
                  columnGap: "8px",
                  borderRadius: "5px",
                  // border: "1px solid #1976d2",
                  // backgroundColor: "#f5f5f5",
                  fontSize: "14px",
                  fontWeight: "500",
                  height: "29px",
                  flexShrink: 0, // Prevent shrinking on smaller screens
                  whiteSpace: "nowrap", // Prevent wrapping
                  cursor: "pointer",
                  transition: "background-color 0.3s ease",
                }}
              >
                <RiFileExcel2Line size={16} />
                <Typography
                  sx={{
                    fontSize: { xs: 10, sm: 10, md: 10, lg: 11, xl: 14 },
                    fontWeight: {
                      xs: "600",
                      sm: "600",
                      md: "600",
                      lg: "600",
                      xl: "500",
                    },
                  }}
                >
                  Download .csv
                </Typography>
              </Button>
            ) : (
              <CSVLink
                headers={tableColumns?.map(({ key, title }) => ({
                  label: title,
                  key,
                }))}
                data={dataGrid}
                filename={`${tableTitle.split(" ").join("-")}.csv`}
                enclosingCharacter={""}
                separator={","}
                style={{
                  textDecoration: "none",
                  color: "#1976d2",
                  padding: "0px 10px",
                  display: "flex",
                  alignItems: "center",
                  columnGap: "8px",
                  borderRadius: "5px",
                  border: "1px solid #1976d2",
                  backgroundColor: "#f5f5f5",
                  fontSize: "14px",
                  fontWeight: "500",
                  height: "30px",
                  flexShrink: 0, // Prevent shrinking on smaller screens
                  whiteSpace: "nowrap", // Prevent wrapping
                }}
              >
                <RiFileExcel2Line size={16} />
                <Typography
                  sx={{
                    fontSize: { xs: 10, sm: 10, md: 10, lg: 11, xl: 14 },
                    fontWeight: {
                      xs: "600",
                      sm: "600",
                      md: "600",
                      lg: "600",
                      xl: "500",
                    },
                  }}
                >
                  {/* {getLng("download_csv", "kaTable")} */}
                </Typography>
              </CSVLink>
            )
          ) : (
            <></>
          )}

          {/* PDF Export Button */}
          {!!downLoadPDF ? (
            <button
              // onClick={exportToPDF}
              onClick={() => pdfAction?.(orientaion ? orientaion : "portrait")}
              style={{
                textDecoration: "none",
                color: "#1976d2",
                padding: "0px 10px",
                display: "flex",
                alignItems: "center",
                columnGap: "8px",
                borderRadius: "5px",
                border: "1px solid #1976d2",
                backgroundColor: "#f5f5f5",
                fontSize: "14px",
                fontWeight: "500",
                height: "30px",
                flexShrink: 0, // Prevent shrinking on smaller screens
                whiteSpace: "nowrap", // Prevent wrapping
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
            >
              <FaFilePdf size={16} />
              <Typography
                sx={{
                  fontSize: { xs: 10, sm: 10, md: 10, lg: 11, xl: 14 },
                  fontWeight: {
                    xs: "600",
                    sm: "600",
                    md: "600",
                    lg: "600",
                    xl: "500",
                  },
                }}
              >
                {/* {getLng("download_pdf", "kaTable")} */}
              </Typography>
            </button>
          ) : (
            <></>
          )}

          {/* Search Input */}
          {isTypeSearch ? (
            FormHandler &&
            setSearchKeyVal &&
            searchText !== undefined &&
            setSearchText !== undefined ? (
              <>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    flexGrow: 1,
                    minWidth: 200,
                    mt: 0.5,
                  }}
                >
                  {/* <PTaxAutoCompleteWrapper
                  control={FormHandler.control}
                  errors={FormHandler.formState.errors}
                  fieldName={"search_dropdown"}
                  // noBorder
                  options={searchDropdownList || []}
                  onChangeFn={(value: any, callBack: any) =>
                    handleChooseAction(value, callBack)
                  }
                  placeholder={`Search By`}
                  rules={{ required: true }}
                  keys={searchDropdownKey}
                  menuLabel={searchDropdownLabel}
                  width={"100%"}
                  height="32px"
                /> */}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    flexGrow: 1,
                    minWidth: 200,
                  }}
                >
                  <input
                    type="text"
                    value={searchText}
                    onChange={(event) =>
                      setSearchText(event.currentTarget.value)
                    }
                    placeholder={`Search ${
                      searchDropdownList?.find(
                        (m) =>
                          m[searchDropdownKey] ===
                          FormHandler?.watch("search_dropdown")
                      )?.[searchDropdownLabel] || ""
                    }`}
                    style={{
                      padding: "7px 12px",
                      borderRadius: "5px",
                      marginBottom:"5px",
                      fontSize: "14px",
                      outline: "none",
                      width: "100%",
                      border: "1px solid #1976d2",
                      transition: "border-color 0.3s ease",
                      paddingRight: "40px",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#1976d2")}
                    onBlur={(e) => (e.target.style.borderColor = "gray")}
                  />
                  <IconButton
                    type="button"
                    sx={{
                      p: "7px",
                      position: "absolute",
                      right: "5px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                    aria-label="search"
                    // onClick={() => {
                    //   if (isSSR) {
                    //     searchAction?.(searchText);
                    //   }
                    // }}
                  >
                    {/* <SearchIcon sx={{ color: "#1976d2" }} /> */}
                  </IconButton>
                </Box>
                <Button
                  onClick={() => {
                    if (isSSR) {
                      searchAction?.(searchText);
                    }
                  }}
                  size="small"
                  variant="outlined"
                  style={{
                    border: "1px solid #1976d2",
                    backgroundColor: "#f5f5f5",
                    color: "#1976d2",
                    textDecoration: "none",
                    // color: "#1976d2",
                    padding: "0px 10px",
                    display: "flex",
                    alignItems: "center",
                    columnGap: "8px",
                    borderRadius: "5px",
                    // border: "1px solid #1976d2",
                    // backgroundColor: "#f5f5f5",
                    fontSize: "14px",
                    fontWeight: "500",
                    height: "29px",
                    flexShrink: 0, // Prevent shrinking on smaller screens
                    whiteSpace: "nowrap", // Prevent wrapping
                    cursor: "pointer",
                    transition: "background-color 0.3s ease",
                  }}
                >
                  <SearchIcon sx={{ color: "#1976d2", fontSize: 20 }} />
                  <Typography
                    sx={{
                      fontSize: { xs: 10, sm: 10, md: 10, lg: 11, xl: 14 },
                      fontWeight: {
                        xs: "600",
                        sm: "600",
                        md: "600",
                        lg: "600",
                        xl: "500",
                      },
                    }}
                  >
                    Search
                  </Typography>
                </Button>
                {searchText && searchText != "" && (
                  <Button
                    onClick={() => {
                      if (isSSR) {
                        searchClear?.();
                      }
                    }}
                    size="small"
                    variant="outlined"
                    style={{
                      border: "1px solid #1976d2",
                      backgroundColor: "#f5f5f5",
                      color: "#1976d2",
                      textDecoration: "none",
                      // color: "#1976d2",
                      padding: "0px 10px",
                      display: "flex",
                      alignItems: "center",
                      columnGap: "8px",
                      borderRadius: "5px",
                      // border: "1px solid #1976d2",
                      // backgroundColor: "#f5f5f5",
                      fontSize: "14px",
                      fontWeight: "500",
                      height: "29px",
                      flexShrink: 0, // Prevent shrinking on smaller screens
                      whiteSpace: "nowrap", // Prevent wrapping
                      cursor: "pointer",
                      transition: "background-color 0.3s ease",
                    }}
                  >
                    <CloseIcon sx={{ color: "#1976d2", fontSize: 20 }} />
                    <Typography
                      sx={{
                        fontSize: { xs: 10, sm: 10, md: 10, lg: 11, xl: 14 },
                        fontWeight: {
                          xs: "600",
                          sm: "600",
                          md: "600",
                          lg: "600",
                          xl: "500",
                        },
                      }}
                    >
                      Clear
                    </Typography>
                  </Button>
                )}
              </>
            ) : (
              <></>
            )
          ) : searchText !== undefined && setSearchText !== undefined ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                position: "relative",
                flexGrow: 1,
                minWidth: 0,
              }}
            >
              <input
                type="text"
                value={searchText}
                onChange={(event) => setSearchText(event.currentTarget.value)}
                placeholder={`Search ${searchTitle || tableTitle}...`}
                style={{
                  padding: "7px 12px",
                  borderRadius: "5px",
                  fontSize: "14px",
                  outline: "none",
                  marginBottom:"5px",
                  width: "100%",
                  border: "1px solid #1976d2",
                  transition: "border-color 0.3s ease",
                  paddingRight: "40px",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#1976d2")}
                onBlur={(e) => (e.target.style.borderColor = "gray")}
              />
              <IconButton
                type="button"
                sx={{
                  p: "7px",
                  position: "absolute",
                  right: "5px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
                aria-label="search"
                onClick={() => {
                  if (isSSR) {
                    searchAction?.(searchText);
                  }
                }}
              >
                <SearchIcon sx={{ color: "#1976d2" }} />
              </IconButton>
            </Box>
          ) : (
            <></>
          )}
        </Grid>
      )}

      {actionBtnsReq ? (
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          lg={3.9}
          xl={3.9}
          mr={0.5}
          gap={1}
          sx={{
            display: "flex",
            // gap: "15px",
            justifyContent: "flex-end",
            // height: "40px",
          }}
        >
          {actionBtns?.map(({ BtnIcon, ...rest }, index) => (
            <Button
              key={`${rest.btnText}-${index}`}
              onClick={() => rest.btnAction()}
              size="small"
              variant="outlined"
              style={{
                border: "1px solid #1976d2",
                backgroundColor: "#f5f5f5",
                color: "#1976d2",
                height: "35px",
              }}
            >
              {BtnIcon !== undefined && <BtnIcon size={20} />}

              <p style={{ textTransform: "capitalize" }}>{rest.btnText}</p>
            </Button>
          ))}
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  );
};

export default TableController;
